<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  mounted() {
    // 初始化主题：从 localStorage 读取并应用到 html 元素
    const theme = this.$store.state.app.theme || 'light';
    document.documentElement.className = theme === 'dark' ? 'theme-dark' : '';
  }
};
</script>

<style lang="scss">
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background-color: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #1c1c1c;
  border-radius: 4px;
  min-height: 40px;
  cursor: pointer;

  &:hover {
    background: #949494;
  }
}
</style>